var map = {
	"./chameleon-theme-az/lib/styleguide/tokens.android.json": "d5QW",
	"./chameleon-theme-az/lib/styleguide/tokens.css.json": "9/cE",
	"./chameleon-theme-az/lib/styleguide/tokens.ios.json": "6x+4",
	"./chameleon-theme-az/lib/styleguide/tokens.js.json": "puA3",
	"./chameleon-theme-az/lib/styleguide/tokens.scss.json": "VudB",
	"./chameleon-theme-az/package.json": "/Yt0",
	"./chameleon-theme-beltel/lib/styleguide/tokens.android.json": "u53d",
	"./chameleon-theme-beltel/lib/styleguide/tokens.css.json": "8V1r",
	"./chameleon-theme-beltel/lib/styleguide/tokens.ios.json": "T10N",
	"./chameleon-theme-beltel/lib/styleguide/tokens.js.json": "FVY9",
	"./chameleon-theme-beltel/lib/styleguide/tokens.scss.json": "F/sP",
	"./chameleon-theme-beltel/package.json": "2t3m",
	"./chameleon-theme-co/lib/styleguide/tokens.android.json": "ToQE",
	"./chameleon-theme-co/lib/styleguide/tokens.css.json": "ZCKR",
	"./chameleon-theme-co/lib/styleguide/tokens.ios.json": "aomW",
	"./chameleon-theme-co/lib/styleguide/tokens.js.json": "JZJp",
	"./chameleon-theme-co/lib/styleguide/tokens.scss.json": "3C6B",
	"./chameleon-theme-co/package.json": "QtDy",
	"./chameleon-theme-dl/lib/styleguide/tokens.android.json": "LRMJ",
	"./chameleon-theme-dl/lib/styleguide/tokens.css.json": "suSM",
	"./chameleon-theme-dl/lib/styleguide/tokens.ios.json": "z+IQ",
	"./chameleon-theme-dl/lib/styleguide/tokens.js.json": "nvPk",
	"./chameleon-theme-dl/lib/styleguide/tokens.scss.json": "nTbV",
	"./chameleon-theme-dl/package.json": "3dB0",
	"./chameleon-theme-ds/lib/styleguide/tokens.android.json": "8r87",
	"./chameleon-theme-ds/lib/styleguide/tokens.css.json": "CZ2F",
	"./chameleon-theme-ds/lib/styleguide/tokens.ios.json": "mr0i",
	"./chameleon-theme-ds/lib/styleguide/tokens.js.json": "NwMf",
	"./chameleon-theme-ds/lib/styleguide/tokens.scss.json": "N5iQ",
	"./chameleon-theme-ds/package.json": "R+ih",
	"./chameleon-theme-ge/lib/styleguide/tokens.android.json": "lLMI",
	"./chameleon-theme-ge/lib/styleguide/tokens.css.json": "PC35",
	"./chameleon-theme-ge/lib/styleguide/tokens.ios.json": "bVqv",
	"./chameleon-theme-ge/lib/styleguide/tokens.js.json": "fxLB",
	"./chameleon-theme-ge/lib/styleguide/tokens.scss.json": "MTI4",
	"./chameleon-theme-ge/package.json": "5ZCT",
	"./chameleon-theme-gva/lib/styleguide/tokens.android.json": "apJB",
	"./chameleon-theme-gva/lib/styleguide/tokens.css.json": "cQMK",
	"./chameleon-theme-gva/lib/styleguide/tokens.ios.json": "CYvD",
	"./chameleon-theme-gva/lib/styleguide/tokens.js.json": "Ia8L",
	"./chameleon-theme-gva/lib/styleguide/tokens.scss.json": "PZSF",
	"./chameleon-theme-gva/package.json": "FiOp",
	"./chameleon-theme-hbvl/lib/styleguide/tokens.android.json": "AIew",
	"./chameleon-theme-hbvl/lib/styleguide/tokens.css.json": "1eoi",
	"./chameleon-theme-hbvl/lib/styleguide/tokens.ios.json": "swWl",
	"./chameleon-theme-hbvl/lib/styleguide/tokens.js.json": "7Gmk",
	"./chameleon-theme-hbvl/lib/styleguide/tokens.scss.json": "i8gt",
	"./chameleon-theme-hbvl/package.json": "4bMO",
	"./chameleon-theme-hd/lib/styleguide/tokens.android.json": "xP7Y",
	"./chameleon-theme-hd/lib/styleguide/tokens.css.json": "y+eB",
	"./chameleon-theme-hd/lib/styleguide/tokens.ios.json": "BFqR",
	"./chameleon-theme-hd/lib/styleguide/tokens.js.json": "p2QY",
	"./chameleon-theme-hd/lib/styleguide/tokens.scss.json": "cLCM",
	"./chameleon-theme-hd/package.json": "Z9Yg",
	"./chameleon-theme-hub/lib/styleguide/tokens.android.json": "C4ou",
	"./chameleon-theme-hub/lib/styleguide/tokens.css.json": "gFsH",
	"./chameleon-theme-hub/lib/styleguide/tokens.ios.json": "eqNx",
	"./chameleon-theme-hub/lib/styleguide/tokens.js.json": "w3UR",
	"./chameleon-theme-hub/lib/styleguide/tokens.scss.json": "pjI5",
	"./chameleon-theme-hub/package.json": "BDod",
	"./chameleon-theme-indo/lib/styleguide/tokens.android.json": "/pIV",
	"./chameleon-theme-indo/lib/styleguide/tokens.css.json": "+rXO",
	"./chameleon-theme-indo/lib/styleguide/tokens.ios.json": "Uke6",
	"./chameleon-theme-indo/lib/styleguide/tokens.js.json": "HAHz",
	"./chameleon-theme-indo/lib/styleguide/tokens.scss.json": "l0Ro",
	"./chameleon-theme-indo/package.json": "M3Bm",
	"./chameleon-theme-ld/lib/styleguide/tokens.android.json": "qDOH",
	"./chameleon-theme-ld/lib/styleguide/tokens.css.json": "fAtJ",
	"./chameleon-theme-ld/lib/styleguide/tokens.ios.json": "Gqoa",
	"./chameleon-theme-ld/lib/styleguide/tokens.js.json": "1fo4",
	"./chameleon-theme-ld/lib/styleguide/tokens.scss.json": "AlWY",
	"./chameleon-theme-ld/package.json": "vvhY",
	"./chameleon-theme-lt/lib/styleguide/tokens.android.json": "C4IZ",
	"./chameleon-theme-lt/lib/styleguide/tokens.css.json": "vU4R",
	"./chameleon-theme-lt/lib/styleguide/tokens.ios.json": "1reT",
	"./chameleon-theme-lt/lib/styleguide/tokens.js.json": "2NDP",
	"./chameleon-theme-lt/lib/styleguide/tokens.scss.json": "YHhl",
	"./chameleon-theme-lt/package.json": "8XU8",
	"./chameleon-theme-lw/lib/styleguide/tokens.android.json": "oDOA",
	"./chameleon-theme-lw/lib/styleguide/tokens.css.json": "NpDx",
	"./chameleon-theme-lw/lib/styleguide/tokens.ios.json": "TSWg",
	"./chameleon-theme-lw/lib/styleguide/tokens.js.json": "F0pK",
	"./chameleon-theme-lw/lib/styleguide/tokens.scss.json": "IM1v",
	"./chameleon-theme-lw/package.json": "PZQg",
	"./chameleon-theme-mh/lib/styleguide/tokens.android.json": "5MhN",
	"./chameleon-theme-mh/lib/styleguide/tokens.css.json": "Cnd4",
	"./chameleon-theme-mh/lib/styleguide/tokens.ios.json": "9Aw+",
	"./chameleon-theme-mh/lib/styleguide/tokens.js.json": "FhnL",
	"./chameleon-theme-mh/lib/styleguide/tokens.scss.json": "0208",
	"./chameleon-theme-mh/package.json": "pXzv",
	"./chameleon-theme-nb-legacy/lib/styleguide/tokens.android.json": "95eu",
	"./chameleon-theme-nb-legacy/lib/styleguide/tokens.css.json": "Os9u",
	"./chameleon-theme-nb-legacy/lib/styleguide/tokens.ios.json": "xVYR",
	"./chameleon-theme-nb-legacy/lib/styleguide/tokens.js.json": "wfdv",
	"./chameleon-theme-nb-legacy/lib/styleguide/tokens.scss.json": "vRDZ",
	"./chameleon-theme-nb-legacy/package.json": "8ps2",
	"./chameleon-theme-nb/lib/styleguide/tokens.android.json": "8i7S",
	"./chameleon-theme-nb/lib/styleguide/tokens.css.json": "EABw",
	"./chameleon-theme-nb/lib/styleguide/tokens.ios.json": "hBbk",
	"./chameleon-theme-nb/lib/styleguide/tokens.js.json": "Lg3Z",
	"./chameleon-theme-nb/lib/styleguide/tokens.scss.json": "6MQq",
	"./chameleon-theme-nb/package.json": "e+fU",
	"./chameleon-theme-nhd/lib/styleguide/tokens.android.json": "B+vY",
	"./chameleon-theme-nhd/lib/styleguide/tokens.css.json": "rOgL",
	"./chameleon-theme-nhd/lib/styleguide/tokens.ios.json": "WyJg",
	"./chameleon-theme-nhd/lib/styleguide/tokens.js.json": "QTLw",
	"./chameleon-theme-nhd/lib/styleguide/tokens.scss.json": "viTh",
	"./chameleon-theme-nhd/package.json": "V+Fr",
	"./chameleon-theme-sw/lib/styleguide/tokens.android.json": "8RR1",
	"./chameleon-theme-sw/lib/styleguide/tokens.css.json": "cefY",
	"./chameleon-theme-sw/lib/styleguide/tokens.ios.json": "ba+P",
	"./chameleon-theme-sw/lib/styleguide/tokens.js.json": "Ku5l",
	"./chameleon-theme-sw/lib/styleguide/tokens.scss.json": "F3dS",
	"./chameleon-theme-sw/package.json": "r2/o",
	"./chameleon-theme-tc/lib/styleguide/tokens.android.json": "lJsH",
	"./chameleon-theme-tc/lib/styleguide/tokens.css.json": "x41I",
	"./chameleon-theme-tc/lib/styleguide/tokens.ios.json": "TDD9",
	"./chameleon-theme-tc/lib/styleguide/tokens.js.json": "qrzf",
	"./chameleon-theme-tc/lib/styleguide/tokens.scss.json": "v7iz",
	"./chameleon-theme-tc/package.json": "2LbM",
	"./chameleon-theme-tel/lib/styleguide/tokens.android.json": "MAqC",
	"./chameleon-theme-tel/lib/styleguide/tokens.css.json": "XhhI",
	"./chameleon-theme-tel/lib/styleguide/tokens.ios.json": "sQnO",
	"./chameleon-theme-tel/lib/styleguide/tokens.js.json": "tKFS",
	"./chameleon-theme-tel/lib/styleguide/tokens.scss.json": "7Ah8",
	"./chameleon-theme-tel/package.json": "7Rpg",
	"./chameleon-theme-vl/lib/styleguide/tokens.android.json": "Y7ZG",
	"./chameleon-theme-vl/lib/styleguide/tokens.css.json": "lAqA",
	"./chameleon-theme-vl/lib/styleguide/tokens.ios.json": "rbAf",
	"./chameleon-theme-vl/lib/styleguide/tokens.js.json": "DKIy",
	"./chameleon-theme-vl/lib/styleguide/tokens.scss.json": "NtJe",
	"./chameleon-theme-vl/package.json": "OhGv",
	"./chameleon-theme-wl/lib/styleguide/tokens.android.json": "daB6",
	"./chameleon-theme-wl/lib/styleguide/tokens.css.json": "9LIX",
	"./chameleon-theme-wl/lib/styleguide/tokens.ios.json": "kcLL",
	"./chameleon-theme-wl/lib/styleguide/tokens.js.json": "GTDs",
	"./chameleon-theme-wl/lib/styleguide/tokens.scss.json": "OCxp",
	"./chameleon-theme-wl/package.json": "sgX9",
	"./chameleon-theme-yc/lib/styleguide/tokens.android.json": "HgQj",
	"./chameleon-theme-yc/lib/styleguide/tokens.css.json": "j22p",
	"./chameleon-theme-yc/lib/styleguide/tokens.ios.json": "gwNL",
	"./chameleon-theme-yc/lib/styleguide/tokens.js.json": "8jYp",
	"./chameleon-theme-yc/lib/styleguide/tokens.scss.json": "JnMq",
	"./chameleon-theme-yc/package.json": "fj+f"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "z5gf";